import Box from '@mui/material/Box';
import React from 'react';

const Logo = () => {
  return (
    <Box
      component="span"
      sx={{
        height: '48px',
        marginRight: '40px',
        marginLeft: '70px',
        width: '100px',
        display: 'inline-block',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
      }}
      className="logo"
      data-testid="landingpage-logo"
    />
  );
};

export default Logo;
